import { createFileRoute } from "@tanstack/react-router";
import { TenantListPage } from "@/components/admin/TenantListPage";

export const Route = createFileRoute("/admin/tenants/")({
  component: TenantListPage,
});
